import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AuthTokenService } from './auth-token.service';
import { RUNTIME_CONFIG } from './runtime-config';
import { TokenRefreshService } from './token-refresh.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const cfg = inject(RUNTIME_CONFIG);
    const auth = inject(AuthTokenService);
    const refresh = inject(TokenRefreshService);
    const isBackend =
        req.url.startsWith(cfg.apiBaseUrl) || req.url.startsWith(cfg.compositionApiBaseUrl);

    return next(req).pipe(
        catchError((err: unknown) => {
            if (!(err instanceof HttpErrorResponse) || err.status !== 401 || !isBackend) {
                return throwError(() => err);
            }

            // Token expired: try to adopt a fresher one from the host and replay the request once.
            // The replayed observable is not re-wrapped by this catchError, so a second 401 can't loop.
            return from(refresh.refreshFromHost()).pipe(
                switchMap((refreshed) => {
                    if (refreshed) {
                        return next(
                            req.clone({ setHeaders: { Authorization: `Bearer ${auth.token}` } }),
                        );
                    }
                    // Nothing newer to use — hand off to the host's full re-auth (reloads the view).
                    notify('Your session has expired. Reloading…', 'warning', 4000);
                    refresh.forceReauth();
                    return throwError(() => err);
                }),
            );
        }),
    );
};
